import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  const contactDetails = [
    {
      id: 1,
      country: 'Nigeria',
      flag: '🇳🇬',
      office: 'Lagos Headquarters',
      address: '15 Admiralty Way, Lekki Phase 1, Lagos, Nigeria',
      phone: '+234 916 008 5052',
      email: 'infoedrianbass@gmail.com',
      hours: 'Mon-Fri: 9:00 AM - 6:00 PM WAT',
      timezone: 'West Africa Time (UTC+1)',
      mapUrl: 'https://www.google.com/maps?q=6.4474,3.4700&z=14&output=embed'
    },
    {
      id: 2,
      country: 'Ghana',
      flag: '🇬🇭',
      office: 'Ghana Office',
      address: 'Accra, Ghana',
      phone: '+233 553 013 492',
      email: 'infoedrianbass@gmail.com',
      hours: 'Mon-Fri: 9:00 AM - 6:00 PM GMT',
      timezone: 'Greenwich Mean Time (UTC+0)',
      mapUrl: 'https://www.google.com/maps?q=5.6037,0.1870&z=14&output=embed'
    },
    {
      id: 3,
      country: 'Cameroon',
      flag: '🇨🇲',
      office: 'Douala Office',
      address: 'Akwa District, Douala, Cameroon',
      phone: '+237 650 616 290',
      email: 'infoedrianbass@gmail.com',
      hours: 'Mon-Fri: 9:00 AM - 6:00 PM WAT',
      timezone: 'West Africa Time (UTC+1)',
      mapUrl: 'https://www.google.com/maps?q=4.0511,9.7679&z=14&output=embed'
    },
    {
      id: 4,
      country: 'South Africa',
      flag: '🇿🇦',
      office: 'Cape Town Branch',
      address: 'V&A Waterfront, Cape Town, South Africa',
      phone: '+27 618 159 013',
      email: 'infoedrianbass@gmail.com',
      hours: 'Mon-Fri: 9:00 AM - 6:00 PM SAST',
      timezone: 'South Africa Standard Time (UTC+2)',
      mapUrl: 'https://www.google.com/maps?q=-33.9025,18.4241&z=14&output=embed'
    }
  ];

  const generalContacts = [
    {
      icon: 'Mail',
      label: 'General Inquiries',
      value: 'infoedrianbass@gmail.com',
      link: 'mailto:infoedrianbass@gmail.com'
    },
    {
      icon: 'Briefcase',
      label: 'Business Partnerships',
      value: 'infoedrianbass@gmail.com',
      link: 'mailto:infoedrianbass@gmail.com'
    },
    {
      icon: 'Users',
      label: 'Mentorship Programs',
      value: 'infoedrianbass@gmail.com',
      link: 'mailto:infoedrianbass@gmail.com'
    },
    {
      icon: 'Palette',
      label: 'Creative Projects (Ed Pulse)',
      value: 'infoedrianbass@gmail.com',
      link: 'mailto:infoedrianbass@gmail.com'
    }
  ];

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-card rounded-xl p-6 md:p-8 shadow-lg border border-border">
        <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6">Regional Offices</h3>
        <div className="space-y-6 md:space-y-8">
          {contactDetails?.map((office) => (
            <div key={office?.id} className="border-b border-border last:border-0 pb-6 md:pb-8 last:pb-0">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-3xl md:text-4xl">{office?.flag}</span>
                <div>
                  <h4 className="text-lg md:text-xl font-semibold">{office?.country}</h4>
                  <p className="text-sm text-muted-foreground">{office?.office}</p>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
                <div className="space-y-3 md:space-y-4">
                  <div className="flex items-start gap-3">
                    <Icon name="MapPin" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-sm font-medium">Address</p>
                      <p className="text-sm text-muted-foreground">{office?.address}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Icon name="Phone" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-sm font-medium">Phone</p>
                      <a href={`tel:${office?.phone}`} className="text-sm text-primary hover:underline">
                        {office?.phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Icon name="Mail" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-sm font-medium">Email</p>
                      <a href={`mailto:${office?.email}`} className="text-sm text-primary hover:underline">
                        {office?.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Icon name="Clock" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-sm font-medium">Business Hours</p>
                      <p className="text-sm text-muted-foreground">{office?.hours}</p>
                      <p className="text-xs text-muted-foreground mt-1">{office?.timezone}</p>
                    </div>
                  </div>
                </div>

                <div className="rounded-lg overflow-hidden h-48 md:h-64 bg-muted">
                  <iframe
                    width="100%"
                    height="100%"
                    loading="lazy"
                    title={`${office?.country} Office Location`}
                    referrerPolicy="no-referrer-when-downgrade"
                    src={office?.mapUrl}
                    className="border-0"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-xl p-6 md:p-8 shadow-lg border border-border">
        <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6">Direct Contact Channels</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {generalContacts?.map((contact, index) => (
            <a
              key={index}
              href={contact?.link}
              className="flex items-start gap-4 p-4 md:p-5 rounded-lg bg-muted hover:bg-primary/10 transition-all border border-transparent hover:border-primary group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary transition-colors">
                <Icon name={contact?.icon} size={20} color="var(--color-primary)" className="group-hover:text-primary-foreground" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium mb-1">{contact?.label}</p>
                <p className="text-sm text-primary truncate">{contact?.value}</p>
              </div>
              <Icon name="ExternalLink" size={16} color="var(--color-muted-foreground)" className="flex-shrink-0 mt-1" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;